import { createEntityAdapter, createSlice } from "@reduxjs/toolkit";

import { listWebhook } from "./action";

export const clientWebhookEntityAdapter = createEntityAdapter({ selectId: (entity) => entity.id });

const initialState = clientWebhookEntityAdapter.getInitialState({
  totalItems: 0,
});

export const clientWebhookSlice = createSlice({
  name: "clientWebhook",
  initialState,
  extraReducers: (builder) => {
    builder.addCase(listWebhook.fulfilled, (state, action) => {
      if (!action.payload.error) {
        clientWebhookEntityAdapter.setAll(state, action.payload.data.items);
        state.totalItems = action.payload.data.totalItems;
      }
    });
  },
});

export default clientWebhookSlice.reducer;
